import React, { useEffect } from 'react';
import { SelectMultiple } from 'tea-component';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { useIntl } from 'umi';
import { useSetSelectDefaultValue } from '../../hooks/init';
import { useKeywordFilterType } from '../../hooks/useKeywordFilterType';
import './index.scss';
import { keywordFilterTypePlaceholder } from '../../constants/placeholder';
import { addFilterBuriedPoint } from '../../utils/point';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

const KeywordFilterTypeSelect = ({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
}: SingleCommonType) => {
  const { formatMessage } = useIntl();

  const {
    selects: filterType,
    setSelects: setFilterType,
    diffClassName,
  } = useSetSelectDefaultValue({
    defaultValue,
    filterValue,
    defaultKey: 'keyword_filter_types',
    options: ['config', 'nlp'],
  });

  const { filterTypeOptions } = useKeywordFilterType();

  const getButtonElement = (isPoint: boolean = false) => {
    if (filterType.length === 2) {
      return isPoint ? 'All' : formatMessage({ id: 'All' });
    }

    return filterTypeOptions?.find((e: any) => filterType.includes(e?.value))
      ?.showText;
  };

  useEffect(() => {
    const text = getButtonElement();

    onChange?.(
      'keywordFilterType',
      commonBackInfo(
        {
          keyword_filter_types: filterType.length === 2 ? [] : filterType,
        },
        { [defaultKey]: text },
      ),
    );
  }, [filterType, formatMessage]);

  return (
    <div className={`dbo-keyword-filter-type-select-wrapper ${diffClassName}`}>
      <SelectMultiple
        className="dbo-keyword-filter-type-select"
        boxClassName="dbo-key-word-select-box"
        appearance="button"
        options={filterTypeOptions}
        value={filterType}
        staging={false}
        matchButtonWidth
        onChange={(value) => {
          setFilterType(value);
        }}
        onClose={() => {
          try {
            addFilterBuriedPoint(
              FilterButtonPoint.keywordFilterType,
              filterType.length === 2 ? 'All' : filterType,
            );
          } catch (error) {}
        }}
        button={
          <div className="dbo-keyword-filter-type-select-text">
            <span className="dbo-keyword-filter-type-select-label">
              {keywordFilterTypePlaceholder[lang]}
            </span>
            {getButtonElement()}
          </div>
        }
      />
    </div>
  );
};

export default KeywordFilterTypeSelect;
